<template lang="html">
    <div class="search-result">   
        <el-table v-if="!customListResult" :data="tableData"
            header-cell-class-name="table-header-cell" tooltip-effect="light"
            @selection-change="handleSelectionChange"
            :row-key="rowKey"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            @sort-change="handleSortChange"
        >
            <slot name="result"></slot>
        </el-table>  
        <div v-else>
            <slot name="customResult"></slot>
        </div>
        <div class="pagination">    
            <div v-if="showPageData"> 
                <el-pagination
                    :current-page.sync="pageData.pageNo"
                    :page-size.sync="pageData.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    layout="total, prev, pager, next, sizes, jumper"
                    :total="pageData.total"
                    prev-text="<"
                    next-text=">"
                    @size-change="handleSearch(1)"
                    @current-change="handleSearch"
                    @prev-click="handleSearch"
                    @next-click="handleSearch"
                >
                </el-pagination> 
            </div>
        </div> 
        <!-- 新增\编辑 -->
        <div>
            <el-dialog :class="[editDialogClass,'common-crud-dialog']" center :visible.sync="editVisible" :close-on-click-modal="false" append-to-body>
                <div v-if="showEditFormTitle"><span class="edit-form-title">{{ editType }}</span></div>
                <div v-else="showEditFormTitle"><span class="edit-form-title"><slot name="customTitle"></slot></span></div>
                <el-form :model="addNewOrEditData" :show-message="false" :rules="rules" ref="form" :label-position="editFormLabelPosition" :label-width="labelWidth">
                    <slot name="editForm"></slot>
                </el-form>                
                <common-confirm :dialogVisiable.sync="confirmEditSaveVisible" :confirm="handlerEditSaveConfirmOK" appendToDialog>
                    <slot v-if="editType == '新增'" name="confirmAddNewMessage"></slot>
                    <slot v-else name="confirmEditMessage"></slot>
                </common-confirm>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleEditConfirmClick()">确认</el-button>
                    <el-button @click="editVisible = false">关闭</el-button>                    
                </div>
            </el-dialog>           
        </div>
        <!-- 确认删除 -->
        <common-confirm :dialogVisiable.sync="confirmDeleteVisible" :confirm="handlerDeleteConfirmOK" appendToDialog>
            <div>
                <slot name="confirmDeleteMessage"></slot>
            </div>
        </common-confirm>
        <!-- 确认批量删除 -->
        <common-confirm :dialogVisiable.sync="confirmBatchDeleteVisible" :confirm="handlerBatchDeleteConfirmOK" appendToDialog>
            <slot name="confirmBatchDeleteMessage"></slot>
        </common-confirm>
        
        <!-- 提示消息 -->
        <common-confirm class="tips-form-class" :dialogVisiable.sync="tipsFormVisible" :confirm="handlerTipsFormVisibleOK" appendToDialog>
            <slot name="tipsFormMessage"></slot>
        </common-confirm>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

  export default {
    props: {
        'addNewOrEditData': {
            type: Object,
            required: false
        },
        'searchData': {
            type: Object,
            required: true
        },
        'searchDataLikeField': {
            type: Object,
            required: false,
            default: function() {return {}}
        },
        'showPageData': {
            type: Boolean,
            required: false,
            default: true
        },
        'tableData': {
            type: Array,
            required: true
        },
        'crudApi': {
            type: Object,
            required: true
        },
        'itemIdName': {
            type: String,
            required: false,
            default: 'id'
        },
        'showEditFormTitle': {
            type: Boolean,
            required: false,
            default: true
        },
        'editFormLabelPosition': {
            type: String,
            required: false,
            default: 'top'
        },
        'handleSearchResult': {
            type: Function,
            required: false
        },
        'handleSelectionChangeResult': {
            type: Function,
            required: false
        },
        'beforeSave': {
            type: Function,
            required: false
        },
        'afterSave': {
            type: Function,
            required: false
        },
        'beforeDelete': {
            type: Function,
            required: false
        },
        'afterDelete': {
            type: Function,
            required: false
        },
        'otherValid': {
            type: Function,
            required: false
        },
        'resetEditForm': {
            type: Function,
            required: false
        },
        'rules': {
            type: Object,
            required: false,
        },
        'editDialogClass': {
            type: String,
            required: false,
            default: 'common-crud-edit-dialog'
        },
        'rowKey': {
            type: String,
            required: false,
            default: 'id'
        },
        'labelWidth': {
            type: String,
            required: false,
            default: 'auto'
        },
        'selectedDataArray': {
            type: Array,
            required: false,
        },
        'defaultPageSize': {
            type: Number,
            required: false,
            default: 20,
        },
        'customListResult': {
            type: Boolean,
            required: false,
            default: false,
        },
        'deleteSuccessMessages': {
            type: String,
            required: false,
            default: '',
        },
        'deleteBatchSuccessMessages': {
            type: String,
            required: false,
            default: '',
        },
        'addSuccessMessages': {
            type: String,
            required: false,
            default: '',
        },
        'editSuccessMessages': {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            editVisible: false,
            confirmEditSaveVisible: false,
            confirmDeleteVisible: false,
            confirmBatchDeleteVisible: false,
            tipsFormVisible: false,
            pageData: {
                pageNo: 1,
                pageSize: this.defaultPageSize,
                total: 0
            },
            sortData: null,
            selectedData: [],
            editType: "",
            currentData: null,            
        }
    },
    computed: {        
        ...mapGetters(['basedataGetName']),
    },
    methods: {
        ...mapActions(['initBaseDataByTypes']),
        formatDateTime2Date(row, column, cellValue, index) {
            if(!cellValue)
                return '';

            return moment(cellValue).format('YYYY-MM-DD');
        },
        indexMethod(index) {
            return index + (this.pageData.pageNo-1)*this.pageData.pageSize + 1;
        },
        handleSearch(pageNo) {      
            let conditionData = {};
            for (const key in this.searchData) {
                if (this.searchData.hasOwnProperty.call(this.searchData, key)) {
                    const element = this.searchData[key];
                    if(element || element === 0) {
                        let val = element;

                        //支持多选查询
                        if(Array.isArray(element)) {
                            val = element.join(',');
                        }

                        if(this.searchDataLikeField && this.searchDataLikeField[key] && val) {
                            val = this.searchDataLikeField[key] + val + this.searchDataLikeField[key];
                        }
                        
                        conditionData[key] = val;                        
                    }
                }
            }
            conditionData.pageNo = pageNo || this.pageData.pageNo;
            conditionData.pageSize = this.pageData.pageSize;

            if(this.sortData) {
                conditionData.column = this.sortData.column;
                conditionData.order = this.sortData.order;
            }

            this.crudApi.list(conditionData)
            .then((res) => {
                if(Array.isArray(res)){
                    let temp = {
                        records: res,
                    }
                    res = temp;
                }

                if(this.handleSearchResult){
                    this.handleSearchResult(res);
                }
                else{
                    this.$emit('update:tableData', res.records)
                }

                this.pageData.pageNo = res.current;
                this.pageData.total = res.total;
            });
        },
        resetObject(obj) {
            for (const key in obj) {
                    if (obj.hasOwnProperty.call(obj, key)) {
                       if(Array.isArray(obj[key])) {
                           obj[key] = [];    
                       }
                       else if(typeof obj[key] == 'object') {
                           obj[key] = {}
                       }
                       else {
                            obj[key] = '';  
                       }                      
                    }
                }
        },
        handleAddNew(specItems) {
            //第一次打开时，没有生成form
            if(this.$refs['form']) {
                this.$refs['form'].resetFields();
            }

            if(this.resetEditForm){
                this.resetEditForm();
            }
            else{
                this.resetObject(this.addNewOrEditData);
                
                if(specItems){
                    _.extend(this.addNewOrEditData, specItems);
                }
            }

            this.editType = "新增";
            this.editVisible = true;
        },
        handleEdit(item, specItems) {    
            if(this.$refs['form']) {
                this.$refs['form'].resetFields();
            }
            
            _.extend(this.addNewOrEditData, item)

            if(specItems){
                _.extend(this.addNewOrEditData, specItems);
            }

            this.currentData = item;

            this.editType = "编辑";
            this.editVisible = true;
        },
        handleEditConfirmClick() {
            let otherValid = true;
            if(this.otherValid) {
                otherValid = this.otherValid();
            }
            this.$refs['form'].validate((valid) => {
                if(valid && otherValid) {
                    this.confirmEditSaveVisible = true;
                }
                else {
                    this.$message.error(this.basedataGetName('SysErrorTip',1));
                }
            })            
        },
        handlerEditSaveConfirmOK() {
            let funName = this.editType == "新增"? 'add' : 'edit';
            let saveData = _.clone(this.addNewOrEditData);
            saveData.id = this.editType == "编辑" ? this.currentData[this.itemIdName] : '';

            if(this.beforeSave){
                this.beforeSave(saveData);
            }

            let skipField = ['delFlag', 'createBy', 'createTime', 'updateBy', 'updateTime'];
            skipField.forEach(el => {
                if (saveData.hasOwnProperty.call(saveData, el)) {
                    delete saveData[el];
                }
            })

            this.crudApi[funName](saveData)
                .then((res) => {
                    if(this.editType == '新增' && this.addSuccessMessages) {
                        this.$message.success(this.addSuccessMessages);
                    }
                    
                    if(this.editType == '编辑' && this.editSuccessMessages) {
                        this.$message.success(this.editSuccessMessages);
                    }

                    this.editVisible = false;
                    this.handleSearch();

                    if(this.afterSave){
                        this.afterSave();
                    }
                });      
        },
        handleDelete(item) {
            this.currentData = item;
            this.confirmDeleteVisible = true;
        },
        handlerDeleteConfirmOK() {
            let deleteData = {}
            deleteData[this.itemIdName] = this.currentData[this.itemIdName];
            this.crudApi.delete(deleteData)
                .then((res) => {
                    if(this.deleteSuccessMessages) {
                        this.$message.success(this.deleteSuccessMessages);
                    }

                    this.confirmDeleteVisible = false;
                    if(this.tableData.length == 1) {
                        this.handleSearch(1);
                    }
                    else {
                        this.handleSearch();
                    }                    

                    if(this.afterDelete){
                        this.afterDelete();
                    }
                });   
        },
        handleSelectionChange(val) {
            this.selectedData = val;
            this.$emit('update:selectedDataArray', val)
            if(this.handleSelectionChangeResult){
                this.handleSelectionChangeResult(val);
            }
        },
        handleBatchDelete() {
            if(this.selectedData.length > 0){
                this.confirmBatchDeleteVisible = true;
            }
        },
        handlerBatchDeleteConfirmOK() {
            if(this.selectedData.length > 0){
                let ids = [];
                for (const data of this.selectedData) {
                ids.push(data.id);
                }
                this.crudApi.deleteBatch({ids:ids.join(',')})
                            .then(res => {  
                                if(this.deleteBatchSuccessMessages) {
                                    this.$message.success(this.deleteBatchSuccessMessages);
                                }

                                if(this.tableData.length == this.selectedData.length) {
                                    this.handleSearch(1);
                                }
                                else {
                                    this.handleSearch();
                                }
                                this.confirmBatchDeleteVisible = false;
                            })
            }
        },
        handleTips() {
            this.tipsFormVisible = true;
        },
        handlerTipsFormVisibleOK() {
            this.tipsFormVisible = false;
        },
        handlerExportExcel(fileName, extendData) {
            let params = null;
            if(this.selectedData.length > 0){
                let ids = [];
                for (const data of this.selectedData) {
                    ids.push(data.id);
                }

                params = {id:ids.join(',')};
            }
            else{
                params = {};

                for (const key in this.searchData) {
                    if (this.searchData.hasOwnProperty.call(this.searchData, key)) {
                        const element = this.searchData[key];
                        if(element || element === 0) {
                            let val = element;

                            //支持多选查询
                            if(Array.isArray(element)) {
                                val = element.join(',');
                            }

                            if(this.searchDataLikeField && this.searchDataLikeField[key] && val) {
                                val = this.searchDataLikeField[key] + val + this.searchDataLikeField[key];
                            }
                            
                            params[key] = val;                        
                        }
                    }
                }
            }

            if(extendData) {
                _.extend(params, extendData)
            }
            let conditionData = {};
            for (const key in params) {
                if (params.hasOwnProperty.call(params, key)) {
                    const element = params[key];
                    if(element || element === 0) {
                        conditionData[key] = element;
                    }
                }
            }
            
            this.crudApi.exportXls(conditionData)
                            .then(res => {
                                // 将`blob`对象转化成一个可访问的`url`
                                let url = window.URL.createObjectURL(new Blob([res.data]));
                                let link = document.createElement('a');
                                link.style.display = 'none';
                                link.href = url;
                                link.setAttribute('download', fileName);
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            })
        },
        handleSortChange(data) {
            //只有1页，排序改变不查后台
            if(this.pageData.total <= this.pageData.pageSize) {
                return;
            }

            if(data.order === 'ascending'){
                this.sortData = {};
                this.sortData.order = 'asc';
                this.sortData.column = data.prop;
            }
            else if(data.order === 'descending') {
                this.sortData = {};
                this.sortData.order = 'desc';
                this.sortData.column = data.prop;
            }
            else {
                this.sortData = null;
            }
            
            this.handleSearch();
        },
    },  
    mounted() {    
        this.initBaseDataByTypes(['SysErrorTip'])
            .then(() => {
            })
    }
  };
</script>

<style lang="less" scoped>
.common-confirm-dialog {
    .common-confirm-info {
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// CommonCrud.vue?2a1d6769